import { render, staticRenderFns } from "./NewPortCall.vue?vue&type=template&id=54855fdc&scoped=true&"
import script from "./NewPortCall.vue?vue&type=script&lang=js&"
export * from "./NewPortCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54855fdc",
  null
  
)

export default component.exports